
import { Language } from './types';

export const SYSTEM_PROMPT = (lang: Language, userName: string) => `
You are BABA, a highly capable bilingual general-purpose voice assistant.
Current User: ${userName}.
Current Language Context: ${lang === Language.EN_GB ? 'British English (en-GB)' : 'European Portuguese (Portugal) (pt-PT)'}.

Identity:
- Accurate, reliable, responsive, and professional.
- Support users in learning, professional work (CVs, coding, data), and everyday advice.
- Calm, polite, and respectful communication style.

Linguistic Constraints:
- If the language is English: Use STRICTLY British English (en-GB). Use British spelling (e.g., 'colour', 'centre') and British terminology. Absolutely no Americanisms.
- If the language is Portuguese: Use STRICTLY European Portuguese (pt-PT) as spoken in Portugal. Include regionalisms from Portugal where appropriate (e.g., Northern, Alentejo, or Insular expressions if relevant). 
- CRITICAL: Do NOT use Brazilian Portuguese (pt-BR) vocabulary or grammar (e.g., use 'tu' or 'você' correctly for Portugal, use 'ecrã' instead of 'tela', 'telemóvel' instead of 'celular').

Guidelines:
- Prioritize factual correctness.
- Use structured reasoning for complex topics.
- If the user is a guest, be extra welcoming.
- If unsure, state limitations clearly; never fabricate.
- Keep responses relatively concise but thorough, optimized for text-to-speech output.
- Respond in the same language as the context provided above.
`;

export const UI_STRINGS = {
  [Language.EN_GB]: {
    title: 'BABA Assistant',
    listening: 'Listening...',
    processing: 'BABA is thinking...',
    speaking: 'Speaking...',
    placeholder: 'Ask BABA anything...',
    welcome: 'Hello, I am BABA. How can I help you today?',
    switchLang: 'Português (PT)',
    errorMic: 'Microphone permission denied.',
    errorService: 'Speech service not allowed. Try typing instead.',
    errorGeneral: 'Something went wrong. Please try again.',
    clearChat: 'Clear History',
    send: 'Send',
    loginTitle: 'Access BABA',
    loginSubtitle: 'Enter your access code to begin',
    accessCode: 'Access Code',
    loginBtn: 'Initialize Assistant',
    invalidCode: 'Invalid access code',
    guestGreeting: 'Hello! I am BABA, your AI assistant. As you are joining as a guest, may I ask what your name is?',
    logout: 'Log out',
    chatHistory: 'Chat History',
    newChat: 'New Chat',
    noChats: 'No conversations saved',
    deleteChat: 'Delete Conversation'
  },
  [Language.PT_PT]: {
    title: 'Assistente BABA',
    listening: 'A ouvir...',
    processing: 'BABA está a pensar...',
    speaking: 'A falar...',
    placeholder: 'Pergunte qualquer coisa...',
    welcome: 'Olá, eu sou o BABA. Como posso ajudar hoje?',
    switchLang: 'English (GB)',
    errorMic: 'Permissão do microfone negada.',
    errorService: 'Serviço de voz não permitido. Tente escrever.',
    errorGeneral: 'Ocorreu um erro. Tente novamente.',
    clearChat: 'Limpar Histórico',
    send: 'Enviar',
    loginTitle: 'Acesso BABA',
    loginSubtitle: 'Insira o código de acesso para começar',
    accessCode: 'Código de Acesso',
    loginBtn: 'Inicializar Assistente',
    invalidCode: 'Código de acesso inválido',
    guestGreeting: 'Olá! Eu sou o BABA, o teu assistente IA. Como estás a entrar como convidado, podes dizer-me o teu nome?',
    logout: 'Terminar sessão',
    chatHistory: 'Histórico',
    newChat: 'Nova conversa',
    noChats: 'Nenhuma conversa guardada',
    deleteChat: 'Eliminar conversa'
  }
};
